import { ApiError } from '../api/client';

/** Sign-in failure → a message an admin can act on. */
export function loginErrorMessage(e: unknown): string {
  if (!(e instanceof ApiError))
    return 'Could not reach the server. Check your connection and try again.';
  if (e.status === 429)
    return 'Too many sign-in attempts from this network. Wait a minute and try again.';
  if (e.code === 'ACCOUNT_LOCKED')
    return 'This account is locked after too many failed attempts. Try again in 15 minutes.';
  if (e.status === 401 || e.code === 'INVALID_CREDENTIALS')
    return 'The email or password is not correct. After 5 failed attempts the account locks for 15 minutes.';
  if (e.status === 400) return 'Check the email and password and try again.';
  if (e.status === 403) return 'This account is disabled. Ask a super admin to re-enable it.';
  return 'Something went wrong on the server. Please try again.';
}

export function mfaErrorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.code === 'INVALID_MFA_CODE')
      return 'That code is not correct. Check the time on your phone and try the newest code.';
    if (e.code === 'MFA_TOKEN_INVALID')
      return 'This sign-in step expired. Enter your password again.';
    if (e.status === 429) return 'Too many attempts. Wait a minute and try again.';
    if (e.status === 401)
      return 'Too many wrong codes: the account is locked for 15 minutes. Start again later.';
  }
  return loginErrorMessage(e);
}

/** `ABCD EFGH`, `abcdefgh`, `abcd-efgh` → `abcd-efgh`. */
export function normalizeRecoveryCode(input: string): string {
  const raw = input.toLowerCase().replace(/[^a-z0-9]/g, '');
  return raw.length === 8 ? `${raw.slice(0, 4)}-${raw.slice(4)}` : input.trim().toLowerCase();
}
